import { Button } from "../ui/button/index.js";
import { AppNotice } from "./AppNotice.js";
import { cn } from "../../lib/utils.js";

export function ProductErrorState({
  title,
  description,
  onRetry,
  retryLabel,
  retryTestId,
  onDismiss,
  dismissLabel,
  testId,
  layout = "page",
}: {
  title: string;
  description: string;
  onRetry?: () => void;
  retryLabel?: string;
  retryTestId?: string;
  onDismiss?: () => void;
  dismissLabel?: string;
  testId?: string;
  layout?: "page" | "inline";
}): React.JSX.Element {
  return (
    <AppNotice
      severity="error"
      testId={testId}
      title={title}
      description={description}
      onDismiss={onDismiss}
      dismissLabel={dismissLabel}
      className={cn(layout === "page" && "mx-auto max-w-md")}
      action={
        onRetry && retryLabel ? (
          <Button type="button" size="sm" variant="outline" onClick={onRetry} data-testid={retryTestId}>
            {retryLabel}
          </Button>
        ) : null
      }
    />
  );
}
